import { DMS_CAPABILITIES } from "models";

import type { DealerLocation } from "models";

export const canAddSubitems = (location?: DealerLocation | null, isLocalIntervention?: boolean) => {
  return Boolean(
    (isLocalIntervention || location?.dms_capability_ids?.includes(DMS_CAPABILITIES.CreateInterventionElement)) &&
      location?.manually_create_intervention_is_enabled &&
      location.can_add_intervention_elements
  );
};
